import React, { useEffect } from 'react';
import { Award, BookOpen, GraduationCap, Target, Users, Zap } from 'lucide-react';

const About = () => {
  useEffect(() => {
    document.title = 'Hakkında - Banu Gökcül | akarma';
  }, []);

  const expertise = [
    'Liderlik ve Yönetim Becerileri',
    'İlişki Yönetimi',
    'Duygusal Çeviklik',
    'Karizma Artırma',
    'Sunum Becerileri',
    'Müzakere',
    'Mindfulness',
    'Dikkat Yönetimi',
    'Farkındalık',
    'Konsantrasyon',
    'Stres Yönetimi',
    'Hedef Belirleme'
  ];

  const education = [
    {
      degree: 'Doktora Çalışmaları',
      institution: 'Marmara Üniversitesi, İşletme Fakültesi',
      field: 'Örgütsel Davranış Bölümü'
    },
    {
      degree: 'Yüksek Lisans',
      institution: 'İstanbul Üniversitesi, İşletme Fakültesi',
      field: 'Davranış Bilimleri Bölümü'
    },
    {
      degree: 'Yüksek Lisans Çalışmaları',
      institution: 'New School, New York',
      field: 'Örgütsel Psikoloji Bölümü'
    },
    {
      degree: 'Psikoloji Dersleri',
      institution: 'Harvard Üniversitesi',
      field: 'Psikoloji'
    },
    {
      degree: 'Lisans',
      institution: 'ODTÜ İktisadi ve İdari Bilimler Fakültesi',
      field: 'Siyaset Bilimleri'
    }
  ];

  const nlpCertificates = [
    'NLP Practitioner Sertifikası, Tampa 2000',
    'NLP Master Practitioner Sertifikası, INLPTA, İstanbul 2002',
    'NLP Trainer Sertifikası, İstanbul 2003',
    'Dünyanın ilk Master Trainerı Dr. Wyatt Woodsmall ile çalışmalar',
    'Master Trainer Robert Smith ile çalışmalar'
  ];

  return (
    <div className="about pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 fade-in">Banu GÖKCÜL, PhD</h1>
            <p className="text-2xl md:text-3xl font-light mb-4">Davranış Bilimleri Uzmanı</p>
            <p className="text-xl opacity-90">Eğitmen, Yazar, Terapist ve Profesyonel Konuşmacı</p>
          </div>
        </div>
      </section>

      {/* Main Bio */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="prose prose-lg max-w-none">
              <p className="text-lg leading-relaxed mb-6">
                14 yıl Bilgi Üniversitesinde ve şimdi Bahçeşehir Üniversitesi Executive MBA Programında, 
                liderlik ve yönetim becerileri konusunda ders vermekte olan Gökcül, 21 yıl önce kurucusu 
                olduğu Akarma Eğitim ve Danışmanlık Merkezinde, eğitimlerin yanı sıra bireysel ve 
                kurumsal koçluk uygulamaları ile edinmiş olduğu deneyim ve bilgilerini ihtiyacı olan 
                kişilerle ve kuruluşlara aktarmaktadır.
              </p>

              <p className="text-lg leading-relaxed mb-6">
                Gökcül, aynı zamanda motivasyon konuşmacısı - key note speaker - olarak farklı 
                sektörlerden yüzlerce kuruma pek çok kez konuşmacı olarak katılmıştır. Ayrıca Gökcül, 
                kamu ve özel sektörde çeşitli kademelerdeki profesyoneller ve yöneticiler için liderlik 
                koçluğu yapmaktadır.
              </p>

              <p className="text-lg leading-relaxed mb-6">
                Gökcül, Türkiye'ye NLP tekniğini ilk getirenlerdendir. Kendisi ulusal ve uluslararası 
                sinema ve tiyatro oyuncuları, CEO'lar, ünlü sporcuları içeren bir müşteri listesi ile 
                20 yıldan fazla süredir mentorluk yapmaktadır. Mentorluk kariyeri boyunca binlerce 
                insanın derin kişisel sorunların üstesinden gelmesine yardımcı oldu.
              </p>

              <p className="text-lg leading-relaxed mb-6">
                Alfa yayınevinde basılan dört kitabın yazarı olan Gökcül, devrim niteliğinde etkinlikleri 
                nedeniyle çeşitli ödüller kazandı. Hızlı dönüşümsel terapi olan ve 'Kuantum Sıçrama 
                için Ayna Tekniği' olarak bilinen çığır açan yeni bir terapi - hızlı iyileşme tekniği yarattı.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Kuantum Sıçrama Tekniği */}
      <section className="py-20 bg-gradient-to-br from-purple-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-8 text-center section-title">
              Kuantum Sıçrama için Ayna Tekniği
            </h2>
            <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl">
              <p className="text-lg leading-relaxed mb-6">
                Bu teknik, Gestalt, Psikodrama, Hipnoz, Beyin Frekans Teknolojileri (bilinçaltı olumlu 
                telkinler-alfa frekans), aile dizimi - konstellasyonu gibi çağımızın; geçmişimizi şimdi 
                iyileştirerek geleceğimizi yaratmak üzere hazırlanmış teknikleri ve Gökcül'ün 
                deneyimlerinin birikimi ile ortaya çıktı.
              </p>
              <p className="text-lg leading-relaxed mb-6">
                Banu Gökcül binlerce danışanı ile çalışmaları sayesinde tamamen kendine ait olan yöntem 
                ve teknikleri geliştirecek düzeye ve esnekliğe kavuşmuş olduğundan isim hakkını da aldığı, 
                'Kuantum Sıçrama için Ayna Tekniği' adı altında topladı.
              </p>
              <div className="bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white p-6 rounded-xl mt-8">
                <p className="text-xl font-semibold text-center">
                  Bu tekniğin gücü ile tüm 'konu'larınızı garanti vererek çözümlemenizi sağlamaktadır.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Expertise */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">Uzmanlık Alanları</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {expertise.map((item, index) => (
                <div key={index} className="flex items-center space-x-3 bg-white p-4 rounded-xl shadow-md card-hover">
                  <div className="w-10 h-10 bg-gradient-to-br from-akarma-blue to-akarma-blue-700 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Target size={20} className="text-white" />
                  </div>
                  <span className="text-gray-700 font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Education */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">Eğitim</h2>
            <div className="space-y-6">
              {education.map((edu, index) => (
                <div key={index} className="bg-white p-6 rounded-xl shadow-md flex items-start space-x-4 card-hover">
                  <div className="w-12 h-12 bg-gradient-to-br from-akarma-blue to-akarma-blue-700 rounded-lg flex items-center justify-center flex-shrink-0">
                    <GraduationCap size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-1">{edu.degree}</h3>
                    <p className="text-akarma-blue font-medium mb-1">{edu.institution}</p>
                    <p className="text-gray-600">{edu.field}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* NLP Certifications */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">NLP Uzmanlığı</h2>
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 md:p-12 rounded-2xl">
              <div className="space-y-4">
                {nlpCertificates.map((cert, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <Award size={24} className="text-akarma-blue flex-shrink-0 mt-1" />
                    <p className="text-lg text-gray-700">{cert}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Achievements */}
      <section className="py-20 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center">Diğer Projeler ve Başarılar</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl">
                <BookOpen size={40} className="mb-4" />
                <h3 className="text-2xl font-bold mb-4">Yayınlar</h3>
                <p className="text-lg opacity-90">
                  100'ün üzerinde makale ve dört tane kişisel liderlik kitabı yazmıştır. Alfa Kitap ve 
                  Kapital Yayıncılık tarafından yayınlanmıştır.
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl">
                <Zap size={40} className="mb-4" />
                <h3 className="text-2xl font-bold mb-4">BFT Teknolojisi</h3>
                <p className="text-lg opacity-90">
                  BFT Beyin Frekans Teknolojisi ile hazırlanmış 100'e yakın Olumlama ve Telkin CD'leri 
                  D&R mağazalarında ve <a href="www.alfafrekans.com" target="_blank">www.alfafrekans.com</a> internet sitesinde satılmaktadır.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Teaching */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title">Akademik Kariyer</h2>
            <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl">
              <div className="flex items-start space-x-6">
                <div className="w-16 h-16 bg-gradient-to-br from-akarma-blue to-akarma-blue-700 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Users size={32} className="text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-4">Bilgi Üniversitesi ve Bahçeşehir Üniversitesi</h3>
                  <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    14 yıl Bilgi Üniversitesinde ders vermiş olup, şu anda Bahçeşehir Üniversitesi Executive 
                    MBA Programında liderlik ve yönetim becerileri konularında eğitim vermektedir.
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed">
                    Kurumsal olarak kişisel ve kişilerarası davranış, koçluk süreci, ilişki yönetimi, 
                    geri bildirim ve performans geliştirme ve yetkinlik bazlı eğitimler, uyum ve anlaşma 
                    yönetimi, stres yönetimi alanlarında yoğunlaşmıştır.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;